import type {SVGProps} from 'react';

export const PhoneIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={45}
		height={45}
		fill="none"
		// viewBox="0 0 45 45"
		{...props}
	>
		<g filter="url(#a)">
			<rect width={36.176} height={36.176} x={4} y={0.176} fill="#fff" rx={10.853} />
			<path
				fill="#01679D"
				fillRule="evenodd"
				d="M17.255 9.22c1.01.014 1.73.77 2.64 1.728.226.236.47.494.741.765 1.32 1.32.945 2.398.642 3.263-.33.943-.614 1.757 1.091 3.462 1.706 1.706 2.519 1.421 3.461 1.09.866-.303 1.94-.68 3.263.64.268.268.521.509.756.732.962.915 1.721 1.638 1.734 2.651.01.863-.514 1.744-1.81 3.039l-.573-.39.486.474c-.287.294-1.05 1.077-2.543 1.086h-.027c-2.253 0-5.192-1.794-8.733-5.335-3.556-3.555-5.353-6.503-5.34-8.76.008-1.493.79-2.257 1.085-2.544l.025-.027.06-.062c1.298-1.297 2.19-1.831 3.042-1.812Zm-.017 1.357h-.008c-.406 0-1.022.406-1.883 1.242l-.172.17h.002l-.04.042-.06.06c-.22.213-.673.655-.677 1.58-.008 1.295.843 3.698 4.941 7.794 4.078 4.078 6.478 4.938 7.775 4.938h.02c.925-.005 1.366-.458 1.578-.676.065-.066.117-.116.154-.146.902-.907 1.363-1.58 1.359-2.014-.006-.441-.555-.962-1.314-1.685-.241-.228-.503-.479-.78-.756-.718-.715-1.072-.593-1.854-.318-1.08.379-2.561.898-4.868-1.41-2.308-2.308-1.791-3.788-1.414-4.87.273-.782.398-1.137-.32-1.855-.28-.28-.532-.546-.764-.79-.718-.755-1.237-1.3-1.675-1.306Zm7.785 1.86a4.66 4.66 0 0 1 3.701 3.701.678.678 0 1 1-1.33.26 3.31 3.31 0 0 0-2.63-2.63.678.678 0 1 1 .259-1.33Zm-.054-3.212a7.842 7.842 0 0 1 6.965 6.958.678.678 0 0 1-1.347.152 6.495 6.495 0 0 0-5.768-5.762.678.678 0 0 1-.6-.75.672.672 0 0 1 .75-.598Z"
				clipRule="evenodd"
			/>
		</g>
		<defs>
			<filter
				id="a"
				width={44.176}
				height={44.176}
				x={0}
				y={0.176}
				colorInterpolationFilters="sRGB"
				filterUnits="userSpaceOnUse"
			>
				<feFlood floodOpacity={0} result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					result="hardAlpha"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				/>
				<feOffset dy={4} />
				<feGaussianBlur stdDeviation={2} />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
				<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_713_7194" />
				<feBlend in="SourceGraphic" in2="effect1_dropShadow_713_7194" result="shape" />
			</filter>
		</defs>
	</svg>
);
